import React, { useContext, useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MdKeyboardArrowRight } from "react-icons/md";
import SettingsHeader from "./SettingsHeader";
import { useNavigate } from "react-router-dom";
import LogoutPrompt from "../modals/LogoutPrompt";
import {
  Bell,
  Bricked,
  Comm,
  Exit,
  Key,
  Lock,
  User,
} from "../svg/GeneralIcons";
import { useManageWallet } from "../../api/settings/wallet";
import { formatAmount } from "../../utils";
import { Toggle, WalletMoney } from "../svg/Settings";
import { FullModal } from "../../modules/world/rmc/modals/fullModal";
import { Card } from "../Card";
import clsx from "clsx";
import { Modal } from "../modals/Modal";
import { useProfile } from "../../api/settings/profile";
import { UserContext } from "../context/UseContext";

export const promptStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "1.2rem",
    paddingBottom: "1rem",
    minWidth: "10%",
    maxWidth: "90%",
    zIndex: "4000",
  },
  overlay: {
    backgroundColor: "rgb(24 24 24 / 10%)",
    overflowY: "auto",
  },
};

function UserSetting() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const { token } = useContext(UserContext);
  const { getProfileInfo } = useProfile();
  const { balance, getBalance, isLoading } = useManageWallet();

  const hasFetched = useRef(false);
  useEffect(() => {
    if (!token || token === "null") return;
    if (!hasFetched.current) {
      hasFetched.current = true;
      getProfileInfo(token, true);
      getBalance();
    }
  }, []);

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 2000 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 2000 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94], // Custom ease curve
          }}
          className="w-full pb-10"
        >
          <SettingsHeader />
          {isLoading ? (
            <div
              style={{
                background: "linear-gradient(180deg, #0A0A0F 0%, #0D1440 100%)",
              }}
              className="flex items-end bg-black justify-between gap-6 p-5 rounded-[10px] mt-7"
            >
              <div>
                <p className="text-[#FFFFFF80] text-sm font-medium">
                  Available balance
                </p>
                <div className="h-6 bg-[#FFFFFF20] rounded mt-2 w-24"></div>
              </div>
              <div className="h-12 bg-[#2741D640] rounded-full w-24"></div>
            </div>
          ) : (
            <div
              style={{
                background: "linear-gradient(180deg, #0A0A0F 0%, #0D1440 100%)",
              }}
              className="flex items-end bg-black justify-between gap-6 p-5 rounded-[10px] mt-7"
            >
              <div>
                <p className="text-[#FFFFFF80] text-sm font-medium">
                  Available balance
                </p>
                <h4 className="text-[#B8C2FF] text-3xl mt-2">{`₦${
                  formatAmount(balance?.balance) ?? 0
                }`}</h4>
              </div>
              <button
                onClick={() => navigate("/settings/wallet")}
                className="text-white bg-[#2741D6] px-3 py-3 rounded-full text-xs font-semibold"
              >
                View Wallet
              </button>
            </div>
          )}

          <div className="mt-5 flex flex-col gap-y-5 pb-3">
            <div className="glassy rounded-2xl py-4 px-5 flex flex-col gap-y-7">
              <div
                onClick={() => navigate("/settings/profile")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <User />
                  <h4 className="text-base font-semibold text-center">
                    Profile Settings
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>

              <div
                onClick={() => navigate("/settings/payment-details")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <WalletMoney />
                  <h4 className="text-base font-semibold text-center ">
                    Payment Details
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
              {/* <div className="flex cursor-pointer items-center justify-between gap-2 880:gap-4">
              <div className="flex items-center gap-4">
                <Verified />
                <h4 className="text-base font-semibold text-center ">
                  Account Verification
                </h4>
              </div>
              <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
            </div> */}
            </div>
            <div className="glassy rounded-2xl py-4 px-5 flex flex-col gap-y-7">
              <div
                onClick={() => navigate("/settings/secure/change-password")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <Lock />
                  <h4 className="text-base font-semibold text-center">
                    Change Password
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
              <div
                onClick={() => navigate("/settings/secure/transaction-pin")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <Key />
                  <h4 className="text-base font-semibold text-center ">
                    Change Transaction PIN
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
              {/* <div className="flex cursor-pointer items-center justify-between gap-2 880:gap-4">
              <div className="flex items-center gap-4">
                <Shield />
                <h4 className="text-base font-semibold text-center ">
                  Two Factor Authentication
                </h4>
              </div>
              <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
            </div> */}
            </div>
            <div className="glassy rounded-2xl py-4 px-5 flex flex-col gap-y-7">
              <div
                onClick={() => navigate("/settings/help")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <Comm />
                  <h4 className="text-base font-semibold text-center">
                    FAQ's and Support
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
              <div
                onClick={() => navigate("/settings/refer-and-earn")}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <Bricked />
                  <h4 className="text-base font-semibold text-center ">
                    Referrals
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
              <div
                onClick={() => setShow(true)}
                className="flex cursor-pointer items-center justify-between gap-2 880:gap-4"
              >
                <div className="flex items-center gap-4">
                  <Bell />
                  <h4 className="text-base font-semibold text-center ">
                    Notifications
                  </h4>
                </div>
                <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
              </div>
            </div>
            <div
              onClick={onOpenModal}
              className="flex cursor-pointer items-center rounded-2xl justify-between py-4 px-5 gap-2 880:gap-4 glassy  mb-5"
            >
              <div className="flex items-center gap-4">
                <Exit className={"text-[#2741D6]"} />
                <h4 className="text-lg font-semibold text-center ">Log out</h4>
              </div>
              <MdKeyboardArrowRight className="text-2xl text-[#0000004D]" />
            </div>
          </div>
          <AnimatePresence>
            {show && (
              <FullModal
                showCloseIcon={true}
                onClose={() => setShow(false)}
                iconClass="!text-primary-black"
                className={clsx(
                  "fixed h-full inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto  ",
                )}
              >
                <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
                  <div className="relative flex items-center justify-center mb-10">
                    <p className="font-bold text-xl text-black">
                      Notifications
                    </p>
                  </div>
                  <Card className="flex justify-between items-center">
                    <p className="text-primary-black text-sm font-semibold">
                      Push notifications
                    </p>
                    <Toggle
                      onClick={() => setIsActive(!isActive)}
                      isActive={isActive}
                    />
                  </Card>
                </div>
              </FullModal>
            )}
          </AnimatePresence>
        </motion.div>
      </AnimatePresence>
      <Modal isOpen={open} onClose={onCloseModal}>
        <LogoutPrompt closeModal={onCloseModal} />
      </Modal>
    </>
  );
}

export default UserSetting;
